import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "../../../common/components/form";

export default function MessageContinue(props) {
    const { t } = useTranslation();

    const CNPanelCompleteMessage = ["panel-message-continue"];
    props.show && CNPanelCompleteMessage.push("show");
    props.end && CNPanelCompleteMessage.push("end");

    return (
        <div className={CNPanelCompleteMessage.join(" ")}>
            <h2 className="panel-message-continue-text">{props.children}</h2>

            <div className="panel-message-continue-button">
                <ButtonBase solid onClick={props.onContinue}>
                    {t("Continue")}
                </ButtonBase>
            </div>
        </div>
    );
}
